import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(1)};
`;

export const Message = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
`;

export const List = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Row = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IconContainer = styled.span`
  line-height: 62.5%;
  font-size: 1.6rem;
`;

export const Email = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
